import { render } from "./productDetailedPage.vue?vue&type=template&id=3018bf06"
import script from "./productDetailedPage.vue?vue&type=script&lang=js"
export * from "./productDetailedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__